// Silent per-order limit, configured in snippets/order-limit.liquid.
(() => {
  const config = window.orderLimit;
  if (!config) return;

  const fetchCart = () => fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const limitedItems = (cart) => cart.items.filter((item) => item.product_id === config.productId);
  const limitedCount = (cart) => limitedItems(cart).reduce((sum, item) => sum + item.quantity, 0);

  // Used by product-form.js before adding to the cart.
  config.wouldExceed = async (variantId, quantity) => {
    if (!config.variantIds.includes(Number(variantId))) return false;
    return limitedCount(await fetchCart()) + (Number(quantity) || 1) > config.max;
  };

  // Brings the cart back to the limit if it got more some other way, removing from the last line first.
  // The bundle discounts split and re-key cart lines after every change, so the cart is re-read each step.
  async function trim() {
    let changed = false;
    for (let step = 0; step < 10; step++) {
      const cart = await fetchCart();
      const excess = limitedCount(cart) - config.max;
      if (excess <= 0) break;
      const item = limitedItems(cart).pop();
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({ id: item.key, quantity: Math.max(item.quantity - excess, 0) }),
      });
      if (!response.ok) break;
      changed = true;
    }
    if (changed) window.location.reload();
  }

  const safeTrim = () => trim().catch((e) => console.error(e));
  safeTrim();
  subscribe(PUB_SUB_EVENTS.cartUpdate, safeTrim);
})();
